/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCustomerById200ResponseAddressesInner } from './GetCustomerById200ResponseAddressesInner';
import {
    GetCustomerById200ResponseAddressesInnerFromJSON,
    GetCustomerById200ResponseAddressesInnerFromJSONTyped,
    GetCustomerById200ResponseAddressesInnerToJSON,
    GetCustomerById200ResponseAddressesInnerToJSONTyped,
} from './GetCustomerById200ResponseAddressesInner';

/**
 * 
 * @export
 * @interface GetCustomerById200Response
 */
export interface GetCustomerById200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200Response
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200Response
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200Response
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200Response
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200Response
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200Response
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200Response
     */
    phoneNumberCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetCustomerById200Response
     */
    creationTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200Response
     */
    internalNote?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerById200Response
     */
    marketingCommunication?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetCustomerById200Response
     */
    birthDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerById200Response
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<GetCustomerById200ResponseAddressesInner>}
     * @memberof GetCustomerById200Response
     */
    addresses: Array<GetCustomerById200ResponseAddressesInner>;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerById200Response
     */
    points: number;
}

/**
 * Check if a given object implements the GetCustomerById200Response interface.
 */
export function instanceOfGetCustomerById200Response(value: object): value is GetCustomerById200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('addresses' in value) || value['addresses'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    return true;
}

export function GetCustomerById200ResponseFromJSON(json: any): GetCustomerById200Response {
    return GetCustomerById200ResponseFromJSONTyped(json, false);
}

export function GetCustomerById200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerById200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'source': json['source'] == null ? undefined : json['source'],
        'phoneNumberCode': json['phoneNumberCode'] == null ? undefined : json['phoneNumberCode'],
        'creationTime': json['creationTime'] == null ? undefined : (new Date(json['creationTime'])),
        'internalNote': json['internalNote'] == null ? undefined : json['internalNote'],
        'marketingCommunication': json['marketingCommunication'] == null ? undefined : json['marketingCommunication'],
        'birthDate': json['birthDate'] == null ? undefined : (new Date(json['birthDate'])),
        'tags': json['tags'] == null ? undefined : json['tags'],
        'addresses': ((json['addresses'] as Array<any>).map(GetCustomerById200ResponseAddressesInnerFromJSON)),
        'points': json['points'],
    };
}

export function GetCustomerById200ResponseToJSON(json: any): GetCustomerById200Response {
    return GetCustomerById200ResponseToJSONTyped(json, false);
}

export function GetCustomerById200ResponseToJSONTyped(value?: GetCustomerById200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'surname': value['surname'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'source': value['source'],
        'phoneNumberCode': value['phoneNumberCode'],
        'creationTime': value['creationTime'] == null ? undefined : ((value['creationTime']).toISOString()),
        'internalNote': value['internalNote'],
        'marketingCommunication': value['marketingCommunication'],
        'birthDate': value['birthDate'] == null ? undefined : ((value['birthDate']).toISOString()),
        'tags': value['tags'],
        'addresses': ((value['addresses'] as Array<any>).map(GetCustomerById200ResponseAddressesInnerToJSON)),
        'points': value['points'],
    };
}

